import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Sentry from '@sentry/node';
import Link from 'next/link';
import React from 'react';
import { Col, Nav, Row } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import Layout from '../components/Layout';
import Section from '../components/Section';
import SwooptyBg from '../components/SwooptyBg';
import Head from '../components/head';
import { FranchiseeProvider } from '../context/Franchisee';
import '../ui/src/scripts/routes/common';

const iconPageNotFound = '/images/icon-404.svg';

function Error({ statusCode, hasGetInitialPropsRun, err }) {
  if (!hasGetInitialPropsRun && err) {
    // getInitialProps is not called in case of
    // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured.
    Sentry.captureException(err, {
      message: 'Internal server error occurred',
      tags: {
        errorType: 'internalServerError',
        environment: 'production',
      },
    });
  }

  if (err) {
    Sentry.captureException(err, {
      message: 'Internal server error occurred',
      tags: {
        errorType: 'internalServerError',
        environment: 'production',
      },
    });
  }

  return (
    <FranchiseeProvider>
      <Layout>
        <Head title='500: Internal Server Error' slug='500' />
        <SwooptyBg />
        <Section className='my-5'>
          <Row className='justify-content-center text-center'>
            <Col xs={12} lg={12} xl={10}>
              <SVG
                src={iconPageNotFound}
                title='A piece of paper'
                className='w-100 mb-4'
              />

              <h1 className='h2 text-center mb-5'>
                Oops! You hit an internal server error...
              </h1>

              <h1 className='h2 text-center mb-5'>
                Please contact the store directly for assistance.
              </h1>

              <p>
                Maybe one of these links will help you find what you&apos;re
                looking for.
              </p>
              <Nav className='d-block d-lg-flex justify-content-center my-5'>
                <Nav.Item>
                  <Nav.Link>
                    <Link href='/locations/'>
                      <a className='btn btn-outline-primary btn-block'>
                        Find a Store <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </Link>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link>
                    <Link href='/services/'>
                      <a className='btn btn-outline-primary btn-block'>
                        Cleaning Packages
                      </a>
                    </Link>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link>
                    <Link href='/book/'>
                      <a className='btn btn-outline-primary btn-block'>
                        Get a Quote
                      </a>
                    </Link>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
          </Row>
        </Section>
      </Layout>
    </FranchiseeProvider>
  );
}

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
